"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsCheckBox = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Checkbox = _interopRequireDefault(require("@mui/material/Checkbox"));
var _FormControlLabel = _interopRequireDefault(require("@mui/material/FormControlLabel"));
var _FormControl = _interopRequireDefault(require("@mui/material/FormControl"));
var _FormHelperText = _interopRequireDefault(require("@mui/material/FormHelperText"));
const _excluded = ["label", "labelComponent", "checked", "onChange", "disabled", "helperText", "checkboxProps", "sx"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * DmsCheckBox - A generic checkbox component using Material-UI
 *
 * @param {string|React.ReactNode} label - The label displayed next to the checkbox (string or JSX element)
 * @param {React.ElementType} labelComponent - A component or element type to customize the label
 * @param {boolean} checked - Whether the checkbox is checked
 * @param {function} onChange - The callback function called when the checkbox state changes
 * @param {boolean} disabled - Whether the checkbox is disabled
 * @param {string} helperText - Helper text displayed below the checkbox
 * @param {object} [checkboxProps] - Additional props to pass to the Checkbox component
 * @param {object} [sx] - Custom styles for the checkbox component
 */
const DmsCheckBox = _ref => {
  let {
      label,
      labelComponent: LabelComponent = 'span',
      checked,
      onChange,
      disabled,
      helperText,
      checkboxProps,
      sx = {}
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const checkboxControl = /*#__PURE__*/_react.default.createElement(_FormControlLabel.default, _extends({
    control: /*#__PURE__*/_react.default.createElement(_Checkbox.default, _extends({
      checked: checked,
      onChange: onChange,
      disabled: disabled,
      sx: sx
    }, checkboxProps)),
    label: /*#__PURE__*/_react.default.createElement(LabelComponent, null, label)
  }, rest));
  if (helperText) {
    return /*#__PURE__*/_react.default.createElement(_FormControl.default, null, checkboxControl, /*#__PURE__*/_react.default.createElement(_FormHelperText.default, null, helperText));
  }
  return checkboxControl;
};
exports.DmsCheckBox = DmsCheckBox;
DmsCheckBox.propTypes = {
  label: _propTypes.default.node.isRequired,
  labelComponent: _propTypes.default.elementType,
  checked: _propTypes.default.bool,
  onChange: _propTypes.default.func.isRequired,
  disabled: _propTypes.default.bool,
  helperText: _propTypes.default.string,
  checkboxProps: _propTypes.default.object,
  sx: _propTypes.default.object
};